import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import ChangePasswordModal from "./ChangePasswordModal";

//import images
import avatar1 from "../../assets/images/avatar.png";

const ProfileDropdown = () => {
  const user = JSON.parse(localStorage.getItem("authUser"))?.data;

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={avatar1}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                Hoşgeldiniz
              </span>
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {user?.nameSurname} {user?.surname}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* 
          <DropdownItem className="p-0">
            <Link to="/profilim" className="dropdown-item">
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profilim</span>
            </Link>
          </DropdownItem>
          */}

          <DropdownItem onClick={toggleModal}>
            <i className="bx bx-lock text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Şifre Değiştir</span>
          </DropdownItem>

          <div className="dropdown-divider"></div>

          <DropdownItem className="p-0">
            <Link to="/logout" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Çıkış Yap
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <ChangePasswordModal isOpen={isModalOpen} toggle={toggleModal} />
    </React.Fragment>
  );
};

export default ProfileDropdown;
